import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import StoryboardApp from 'storyboard/components/storyboard-app';
import Api from 'common/middleware/api';

class StoryboardAppContainer extends React.Component {
  static propTypes = {
    dashboards: PropTypes.array,
    data: PropTypes.object.isRequired,
    enums: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    report: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
  };

  constructor() {
    super();

    // If a user updates a storyboard configuration,
    // the updated configuration won't be reflected
    // by storyboard instances until they reload.
    // To ensure that instances pick up the new config,
    // this sets a timeout of 30 minutes, after
    // which any change to the router (as a result
    // of autoplay navigation or user navigation),
    // will force a complete page reload.
    this.shouldReload = false;
    setTimeout(() => {
      this.shouldReload = true;
    }, moment.duration(30, 'minutes').asMilliseconds());
  }

  UNSAFE_componentWillMount() {
    Api.CSRF = this.props.settings.csrf;
    Api.HOST = this.props.settings.hosts.api;
    Api.STORYBOARD_ID = this.props.data.id;
  }

  componentDidUpdate(prevProps) {
    if (this.shouldReload && this.props.location !== prevProps.location) {
      // Thirty minutes have elapsed since storyboard last
      // did a full refresh. Take advantage of the route
      // change and reload the page.
      window.location.reload(true);
    }
  }

  render() {
    return (
      <StoryboardApp
        dashboards={this.props.dashboards}
        data={this.props.data}
        enums={this.props.enums}
        location={this.props.location}
        report={this.props.report}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.data,
  dashboards: state.dashboards,
  enums: state.enums,
  report: state.report,
  settings: state.settings,
});

export default connect(mapStateToProps)(StoryboardAppContainer);
